import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Avatar from "./Avatar";
import axios from "axios";
import "./Admin.css";

// Student Modal
const StudentModal = ({ user, onClose, refreshData }) => {
  const isEdit = !!user?.UserID;
  const [editMode, setEditMode] = useState(isEdit);
  const [formData, setFormData] = useState({
    FirstName: user?.FirstName || "",
    LastName: user?.LastName || "",
    Email: user?.Email || "",
    Contact_Number: user?.Contact_Number || "",
    Subjects: user?.Subjects || "",
    Gender: user?.Gender || "Male",
    Grade: user?.Grade || "",
    Board: user?.Board || "",
    School: user?.School || "",
    Parent_Name: user?.Parent_Name || "",
    Parent_Number: user?.Parent_Number || "",
    Parent_Email: user?.Parent_Email || "",
    Slot_Availablity: user?.Slot_Availablity || "",
    active: user?.active || false
  });

   return (
    <div className="modal-overlay">
      <div className="modal">
        <h2>{isEdit ? "Edit Student" : "Add Student"}</h2>
        <button className="modal-close" onClick={onClose}>X</button>
        <div className="modal-body">
          <label>First Name</label>
          <input name="FirstName" value={formData.FirstName}/>
          <label>Last Name</label>
          <input name="LastName" value={formData.LastName}/>
          <label>Email</label>
          <input name="Email" value={formData.Email}/>
          <label>Contact</label>
          <input name="Contact_Number" value={formData.Contact_Number} />
          <label>Subjects</label>
          <input name="Subjects" value={formData.Subjects}/>
          <label>Gender</label>
          <select name="Gender" value={formData.Gender}>
          <option value="Male">Male</option>
          <option value="Female">Female</option>
          </select>
          <label>Grade</label>
          <input name="Grade" value={formData.Grade}/>
          <label>Board</label>
          <input name="Board" value={formData.Board}/>
          <label>School</label>
          <input name="School" value={formData.School}/>
          <label>Parent/Guardian's Name</label>
          <input name="Parent_Name" value={formData.Parent_Name}/>
          <label>Parent/Guardian's Contact</label>
          <input name="Parent_Number" value={formData.Parent_Number}/>
          <label>Parent/Guardian's Email</label>
          <input name="Parent_Email" value={formData.Parent_Email}/>
          <label>User Availability</label>
          <textarea name="Availability" rows={5} cols={40} value={formData.Slot_Availablity}/>
        </div>
      </div>
    </div>
  );
};

// Tutor Modal
const TutorModal = ({ user, onClose, refreshData }) => {
  const isEdit = !!user?.UserID;
  const [editMode, setEditMode] = useState(isEdit);
  const [formData, setFormData] = useState({
    FirstName: user?.FirstName || "",
    LastName: user?.LastName || "",
    Email: user?.Email || "",
    Contact_Number: user?.Contact_Number || "",
    Subjects: user?.Subjects || "",
    Gender: user?.Gender || "Male",
    active: user?.active || false,
    Experience: user?.Experience || "",
    Slot_Availablity: user?.Slot_Availablity || "",
    Tutor_Grade: user?.Tutor_Grade || "",
    Tutor_Board: user?.Tutor_Board || "",
    Qualification: user?.Qualification || "",
    Known_Language: user?.Known_Language || "",
  });

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h2>{isEdit ? "Edit Tutor" : "Add Tutor"}</h2>
        <button className="modal-close" onClick={onClose}>X</button>
        <div className="modal-body">
          <label>First Name</label>
          <input name="FirstName" value={formData.FirstName}/>
          <label>Last Name</label>
          <input name="LastName" value={formData.LastName}/>
          <label>Email</label>
          <input name="Email" value={formData.Email}/>
          <label>Contact</label>
          <input name="Contact_Number" value={formData.Contact_Number}/>
          <label>Subjects you teach</label>
          <input name="Subjects" value={formData.Subjects}/>
          <label>Grade you teach</label>
          <input name="Tutor_Grade" value={formData.Tutor_Grade}/>
          <label>Curriculum you are aware of</label>
          <input name="Tutor_Board" value={formData.Tutor_Board}/>
          <label>Qualification</label>
          <input name="Qualification" value={formData.Qualification}/>
          <label>Known Language</label>
          <input name="Known_Language" value={formData.Known_Language}/>
          <label>Experience</label>
          <input name="Experience" value={formData.Experience}/>
          <label>Gender</label>
          <select name="Gender" value={formData.Gender}>
          <option value="Male">Male</option>
          <option value="Female">Female</option>
          </select>
          <label>User Availability</label>
          <textarea name="Availability" rows={5} cols={40} value={formData.Slot_Availablity}/>
        </div>
      </div>
    </div>
  );
};

// Main Component
const Contacts = () => {
  const navigate = useNavigate();
  useEffect(() => {
    const username = sessionStorage.getItem("username");
    if (!username) {
      navigate("/Signin"); // redirect if not logged in
    }
  }, [navigate]);
  const userName = sessionStorage.getItem("username"); // Replace with dynamic data if needed
  const userType = sessionStorage.getItem("userType"); 
  const userImage = "https://broken-link.com/avatar.png"; // Replace with real or test URL
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [modalType, setModalType] = useState(""); // "Student" or "Tutor"
  const [searchQuery, setSearchQuery] = useState("");
  const [istClock, setIstClock] = useState("");
  const fetchUsers = async () => {
    try {
      //const res = await axios.get("http://localhost:8000/api/users");
      const res = await axios.get("https://alphabeta4success.com/api/users");
      setUsers(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const searchUsers = async () => {
    if (searchQuery.trim() === "") {
      fetchUsers();
      return;
    }
    try {
      //const res = await axios.get(`http://localhost:8000/api/search/${searchQuery}`);
      const res = await axios.get(`https://alphabeta4success.com/api/search/${searchQuery}`);
      setUsers(res.data);
    } catch (err) {
      console.error(err);
    }
  };
  
  const openModal = (user) => {
    setSelectedUser(user);
    setModalType(user.User_Type);
  };

  const closeModal = () => {
    setSelectedUser(null);
    setModalType("");
  };

  useEffect(() => { 
    
    fetchUsers(); 

    const clockInterval = setInterval(() => {
      const ist = new Date().toLocaleTimeString("en-IN", {
        hour12: true,
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        timeZone: "Asia/Kolkata",
      });
      setIstClock(ist);
    }, 1000);

    return () => {
      clearInterval(clockInterval);
    };
  }, []);

  return (
    <div>
      <section id="sidebar">
        <Link to="#" className="brand">
        <img
          src="/Assets/images/AB4S_logo.png"
          alt="AB4S"
          className="sidebar-logo"
        />
        </Link>
        {userType === "Admin" && (
        <> 
          <ul className="side-menu top">
            <li><Link to="/AdminDashboard"><i className="bx bxs-dashboard"></i><span className="text">Dashboard</span></Link></li>
            <li><a href="https://alphabeta4success.com/action.html" target="_blank"
                rel="noopener noreferrer"><i className="bx bx-video"></i><span className="text">Classroom</span></a></li>
            <li><Link to="#"><i className="bx bx-file"></i><span className="text">File Manager</span></Link></li>
            <li><Link to="/Allocation"><i className="bx bxs-book-content"></i><span className="text">Allocation</span></Link></li>
            <li><Link to="/Scheduler"><i className="bx bxs-calendar-check"></i><span className="text">Re-scheduler</span></Link></li>
            <li><Link to="/UserManagement"><i className="bx bxs-group"></i><span className="text">User Management</span></Link></li>
            <li className="active"><Link to="/Contacts"><i className="bx bx-id-card"></i><span className="text">Contacts</span></Link></li>
            <li><Link to="/Reports"><i className="bx bx-download"></i><span className="text">Reports</span></Link></li>
            <li><Link to="/ResetPassword"><i className="bx bx-message-edit"></i><span className="text">Reset Password</span></Link></li>
            <li><Link to="#"><i className="bx bx-calendar-event"></i><span className="text">Calender</span></Link></li>
          </ul>
          <ul className="side-menu">
            <li><Link to="#"><i className="bx bxs-cog"></i><span className="text">Settings</span></Link></li>
            <li><Link to="/Signin" className="logout"><i className="bx bx-log-out"></i><span className="text">Logout</span></Link></li>
          </ul>
        </>
        )}

        {userType === "Tutor" && (
        <> 
            <ul className="side-menu top">
            <li><Link to="/TutorDashboard"><i className="bx bxs-dashboard"></i><span className="text">Dashboard</span></Link></li>
            <li><Link to="#"><i className="bx bx-file"></i><span className="text">File Manager</span></Link></li>
            <li><Link to="/Scheduler"><i className="bx bxs-calendar-check"></i><span className="text">Re-scheduler</span></Link></li>
            <li><Link to="/ResetPassword"><i className="bx bx-message-edit"></i><span className="text">Reset Password</span></Link></li>
            <li><Link to="#"><i className="bx bx-calendar-event"></i><span className="text">Calender</span></Link></li>
           </ul>
           <ul className="side-menu">
            <li><Link to="#"><i className="bx bxs-cog"></i><span className="text">Settings</span></Link></li>
            <li><Link to="/Signin" className="logout"><i className="bx bx-log-out"></i><span className="text">Logout</span></Link></li>
           </ul>
        </>
        )}
      </section>
      <section id="content">
      <nav>
          <i className="bx bx-menu"></i>
          <h3><span className="highlight-purple">Happy Learning <i className='bx bxs-smile'></i></span></h3>
          <form onSubmit={(e) => { e.preventDefault(); searchUsers(); }}>
            <div className="form-input">
              <input type="search" placeholder="Search by Username..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)}/>
              <button type="submit" className="search-btn" onClick={searchUsers}>
                <i className="bx bx-search"></i>
              </button>
            </div>
          </form>
          <input type="checkbox" id="switch-mode" hidden />
          <label htmlFor="switch-mode" className="switch-mode"></label>
          <div className="topbar-right" style={{ display: "flex", alignItems: "center", gap: 30 }}>
            <span style={{ marginRight: "6px", fontWeight: 600 }}>
              ⏰ -  {istClock} : IST
            </span>
            <span style={{ marginLeft: 8 }}><h3>Welcome, {userName}</h3></span>
            <Avatar name={userName} src={userImage} size={30} className="avatar" />
          </div>
        </nav>
        <main>
        <div className="head-title">
            <div className="left">
              <h2>Contacts</h2>
              <ul className="breadcrumb">
              </ul>
            </div>
          </div>
           <div className="table-data">
          <table className="user-table">
            <thead>
              <tr>
                  <th>UserID</th>
                  <th>First Name</th>
                  <th>Last Name</th>
                  <th>Email</th>
                  <th>Contact_Number</th>
                  <th>Whatsapp_Number</th>
                  <th>Gender</th>
                  <th>User_Type</th>
                  <th>Subjects</th>
                  <th>Country</th>
                  <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {users.length ? users.map(user => (
                <tr key={user.UserID}>
                  <td>
                    <button className="link-button" onClick={() => openModal(user)}>
                      {user.UserID}
                    </button>
                  </td>
                  <td>{user.FirstName}</td>
                  <td>{user.LastName}</td>
                  <td>{user.Email}</td>
                  <td>{user.Contact_Number}</td>
                  <td>{user.Whatsapp_number}</td>
                  <td>{user.Gender}</td>
                  <td>{user.User_Type}</td>
                  <td>{user.Subjects}</td>
                  <td>{user.Country}</td>
                  <td>{user.Status}</td>
                </tr>
              )) : <tr><td colSpan="10">No users found.</td></tr>}
            </tbody>
          </table>
          </div> 
        </main>

        {modalType === "Student" &&
          <StudentModal user={selectedUser} onClose={closeModal} refreshData={fetchUsers} />}
        {modalType === "Tutor" &&
          <TutorModal user={selectedUser} onClose={closeModal} refreshData={fetchUsers} />}
        {modalType === "Admin" &&
          <TutorModal user={selectedUser} onClose={closeModal} refreshData={fetchUsers} />}
      </section>
    </div>
  );
};

export default Contacts;
